import "owl.carousel2";
import "owlcarousel2-filter";

import Isotope from "isotope-layout";
import InfiniteScroll from "infinite-scroll";
import imagesLoaded from "imagesloaded";
import Cookies from "js-cookie";

import Util from "../util/Util";

InfiniteScroll.imagesLoaded = imagesLoaded;
import jQueryBridget from "jquery-bridget";

jQueryBridget("isotope", Isotope, $);

import ScrollMagic from "scrollmagic";

import {gsap} from "gsap";
import {InertiaPlugin} from "gsap/InertiaPlugin";

gsap.registerPlugin(InertiaPlugin);
import {Calendar} from "@fullcalendar/core";
import interactionPlugin from "@fullcalendar/interaction";
import dayGridPlugin from "@fullcalendar/daygrid";
import bootstrapPlugin from "@fullcalendar/bootstrap";


export default {
    init() {
        /* JS GESTIONE ANIMAZIONE DI APERTURA/CHIUSURA BLOCCO LOGHI */
        if ($(".open-loghi").length > 0) {
            let openLoghiButton = $(".open-loghi");
            openLoghiButton.on("click", function (e) {
                e.preventDefault();
                if ($(".block-collapse").length > 0) {
                    let blockLoghiCollapse = $(".block-collapse");
                    if (blockLoghiCollapse.hasClass("open")) {
                        if (($(window).width() < 768) || ($(window).width() > 991 && $(window).width() < 1200)) {
                            gsap.to(blockLoghiCollapse, {height: 180, duration: 1});
                        } else {
                            gsap.to(blockLoghiCollapse, {height: 280, duration: 1});
                        }
                        blockLoghiCollapse.removeClass("open");
                        openLoghiButton.removeClass("rotate");
                    } else {
                        gsap.to(blockLoghiCollapse, {height: "auto", duration: 1});
                        blockLoghiCollapse.addClass("open");
                        openLoghiButton.addClass("rotate");
                    }
                }
            });
        }

        if ($(".calendar-container").length > 0) {
            $(".nst-new-calendar").each(function () {
                var calendarEl = document.getElementById($(this).attr("id"));
                var events = [];
                $(this).parent().find(".nst-new-events-js").each(function () {

                    var start = $(this).data("start").split("/");

                    var event = {
                        title: $(this).data("title"),
                        start: start[2] + "-" + start[1] + "-" + start[0],
                        url: $(this).data("url"),
                    };

                    var color = $(this).data("color");

                    if ($(this).data("end")) {
                        var end = $(this).data("end").split("/");
                        Object.assign(event, {end: end[2] + "-" + end[1] + "-" + end[0] + "T11:30:00"});
                    }

                    if ($(this).data("weekly")) {
                        var weekly = $(this).data("weekly");
                        var startRecur = $(this).data("start").split("/");
                        var endRecur = $(this).data("end").split("/");
                        Object.assign(event, {daysOfWeek: weekly, startRecur: startRecur[2] + "-" + startRecur[1] + "-" + startRecur[0], endRecur: endRecur[2] + "-" + endRecur[1] + "-" + endRecur[0]});
                    }

                    if ($(this).hasClass("event")) {
                        if (color.length > 0) {
                            Object.assign(event, {backgroundColor: color, borderColor: color});
                        } else {
                            Object.assign(event, {backgroundColor: "#327B81", borderColor: "#327B81"});
                        }
                    }

                    if ($(this).hasClass("course")) {
                        if (color.length > 0) {
                            Object.assign(event, {backgroundColor: color, borderColor: color});
                        } else {
                            Object.assign(event, {backgroundColor: "#B8543B", borderColor: "#B8543B"});
                        }
                    }

                    events.push(event);
                });

                var calendar = new Calendar(calendarEl, {
                    plugins: [interactionPlugin, dayGridPlugin, bootstrapPlugin],
                    themeSystem: "bootstrap",
                    timeZone: "local",
                    locale: "it",
                    header: {
                        left: "today",
                        center: "title",
                        right: "prev,next",
                    },
                    buttonText: {
                        today: "Oggi",
                        month: "Mese",
                        week: "Settimana",
                        day: "Giorno",
                    },
                    titleFormat: {
                        month: "long",
                        year: "numeric",
                    },
                    columnHeaderFormat: {
                        weekday: "short",
                    },
                    firstDay: 1,
                    displayEventTime: false,
                    navLinks: true,
                    editable: false,
                    eventLimit: true,
                    allDay: false,
                    events: events,
                });
                calendar.render();
            })
        }
    },
    finalize() {

    },
    onLoad() {

        /* JS INIZIALIZZAZIONE OWLCAROUSEL FLEX-TEXT-PLUS-IMAGE.BLADE.PHP */
        let sliderTxtPlusImage = $(".images-slider");
        if (sliderTxtPlusImage.length > 0) {
            sliderTxtPlusImage.owlCarousel({
                loop: false,
                items: 1,
                nav: true,
                navText: ["<i class=\"far fa-chevron-left\"></i>", "<i class=\"far fa-chevron-right\"></i>"],
                dots: true,
                animateIn: "fadeIn",
                animateOut: "fadeOut",
            });
        }

        /* JS INIZIALIZZAZIONE OWLCAROUSEL FLEX-GALLERY.BLADE.PHP */
        let gallerySlider = $(".gallery .gallery-slider");
        if (gallerySlider.length > 0) {
            gallerySlider.owlCarousel({
                loop: false,
                nav: true,
                navText: ["<i class=\"far fa-chevron-left\"></i>", "<i class=\"far fa-chevron-right\"></i>"],
                dots: true,
                animateIn: "fadeIn",
                animateOut: "fadeOut",
                center: true,
                responsive: {
                    0: {
                        items: 2,
                        margin: 10,
                    },
                    576: {
                        items: 2,
                        margin: 60,
                    },
                    991: {
                        items: 2,
                        margin: 60,
                    },
                    1200: {
                        items: 2,
                        margin: 100,
                    },
                },
            });
        }

        /* JS INIZIALIZZAZIONE OWLCAROUSEL FLEX-SLIDER-ARTICOLI-CORRELATI.BLADE.PHP */
        let sliderArticoliCorrelati = $(".correlati-slider");
        if (sliderArticoliCorrelati.length > 0) {
            $.slidersliderArticoliCorrelati = sliderArticoliCorrelati.owlCarousel({
                loop: false,
                nav: true,
                navText: ["<i class=\"far fa-chevron-left\"></i>", "<i class=\"far fa-chevron-right\"></i>"],
                dots: false,
                animateIn: "fadeIn",
                animateOut: "fadeOut",
                responsive: {
                    0: {
                        items: 2,
                        margin: 10,
                    },
                    576: {
                        items: 2,
                        margin: 60,
                    },
                    991: {
                        items: 3,
                        margin: 60,
                    },
                    1200: {
                        items: 4,
                        margin: 100,
                    },
                },
            });

            // Filter slider post
            $(".slider-post.filter-value").each(function () {
                if (!$(this).hasClass("active")) {
                    let cat = "." + $(this).data("value");
                    let isPresent = $(".single" + cat).length;
                    $(this).on("click", function () {
                        $(".slider-post.filter-value").removeClass("active");
                        $(".slider-post.filter-reset").addClass("disabled").removeClass("active");
                        $(this).addClass("active");

                        let cat = $(this).data("value");
                        let slider = $(".correlati-slider");
                        slider.addClass("hide");
                        slider.on("transitionend", function () {
                            $.slidersliderArticoliCorrelati.owlcarousel2_filter("." + cat);
                            $(this).off("transitionend");
                            $(this).removeClass("hide");
                        });
                    });
                    if (isPresent <= 0) {
                        $(this).css("display", "none");
                    }
                }
            });

            $(".slider-post.filter-reset").on("click", function () {
                if (!$(this).hasClass("active")) {
                    $(".slider-post.filter-value").removeClass("active");
                    $(".slider-post.filter-reset").removeClass("disabled");
                    $(this).addClass("active");

                    let slider = $(".correlati-slider");
                    slider.addClass("hide");
                    slider.on("transitionend", function () {
                        $.slidersliderArticoliCorrelati.owlcarousel2_filter("*");
                        $(this).off("transitionend");
                        $(this).removeClass("hide");
                    });
                }
            });
        }

        /* JS INIZIALIZZAZIONE ISOTOPE E FILTRI FLEX-GRIGLIA-ARTICOLI-CORRELATI.BLADE.PHP */
        let grigliaArticoliCorrelati = $(".correlati-griglia");
        if (grigliaArticoliCorrelati.length > 0) {
            let iso = new Isotope(".correlati-griglia", {
                itemSelector: ".single-articolo",
                percentPosition: true,
                masonry: {
                    columnWidth: ".grid-sizer",
                },
            });

            if ($(".older_post a").length === 0) {
                $(".load-more-link").addClass("hide");
                $(".no-more-post").removeClass("hide");
            } else {
                $(".no-more-post").addClass("hide");
            }

            if (grigliaArticoliCorrelati.length > 0 && $(".older_post a").length > 0) {
                let elem = document.querySelector(".correlati-griglia");

                new InfiniteScroll(elem, {
                    path: ".older_post a",
                    append: ".single-articolo",
                    history: false,
                    status: ".page-load-status",
                    scrollThreshold: false,
                    button: ".load-more-link",
                    outlayer: iso,
                    checkLastPage: true,
                });
            }

            // Filter isotope grid post
            $(".griglia-correlati-row .isotope.filter-value").each(function () {
                let cat = "." + $(this).data("value");
                let isPresent = $(".griglia-correlati-row .single-articolo" + cat).length;
                $(this).on("click", function () {
                    iso.arrange({filter: cat});
                    $(".griglia-correlati-row .isotope.filter-value").removeClass("active");
                    $(".griglia-correlati-row .isotope.filter-reset").removeClass("active");
                    $(this).addClass("active");
                });
                if (isPresent <= 0) {
                    $(this).css("display", "none");
                }
            });

            $(".griglia-correlati-row .isotope.filter-reset").on("click", function () {
                iso.arrange({filter: "*"});
                $(".griglia-correlati-row .isotope.filter-value").removeClass("active");
                //$(".isotope.filter-reset").addClass("disabled");
                $(this).addClass("active");
            });

            // Filter slider post
            $(".griglia-correlati-row .slider-post.filter-value").each(function () {
                if (!$(this).hasClass("active")) {
                    let cat = "." + $(this).data("value");
                    let isPresent = $(".griglia-correlati-row .single" + cat).length;
                    $(this).on("click", function () {
                        $(".griglia-correlati-row .slider-post.filter-value").removeClass("active");
                        $(".griglia-correlati-row .slider-post.filter-reset").addClass("disabled").removeClass("active");
                        $(this).addClass("active");

                        let cat = $(this).data("value");
                        let slider = $(".correlati-slider");
                        slider.addClass("hide");
                        slider.on("transitionend", function () {
                            $.slidersliderArticoliCorrelati.owlcarousel2_filter("." + cat);
                            $(this).off("transitionend");
                            $(this).removeClass("hide");
                        });
                    });
                    if (isPresent <= 0) {
                        $(this).css("display", "none");
                    }
                }
            });

            $(".griglia-correlati-row .slider-post.filter-reset").on("click", function () {
                if (!$(this).hasClass("active")) {
                    $(".griglia-correlati-row .slider-post.filter-value").removeClass("active");
                    $(".griglia-correlati-row .slider-post.filter-reset").removeClass("disabled");
                    $(this).addClass("active");

                    let slider = $(".correlati-slider");
                    slider.addClass("hide");
                    slider.on("transitionend", function () {
                        $.slidersliderArticoliCorrelati.owlcarousel2_filter("*");
                        $(this).off("transitionend");
                        $(this).removeClass("hide");
                    });
                }
            });
        }

        /* JS INIZIALIZZAZIONE ISOTOPE E FILTRI FLEX-SERVIZI-GRIGLIA-CON-FILTRI.BLADE.PHP */
        let grigliaService = $(".service-griglia");
        if (grigliaService.length > 0) {
            /* Isotope */
            let iso = new Isotope(".service-griglia", {
                itemSelector: ".single-service",
                percentPosition: true,
                masonry: {
                    columnWidth: ".grid-sizer",
                },
            });

            /* Infinite scroll */
            if ($(".older_post a").length === 0) {
                $(".load-more-link").addClass("hide");
                $(".load-more-link").removeClass("hide");
            } else {
                $(".no-more-post").addClass("hide");
            }

            if (grigliaService.length > 0 && $(".older_post a").length > 0) {
                let elem = document.querySelector(".service-griglia");
                new InfiniteScroll(elem, {
                    path: ".older_post a",
                    append: ".single-service",
                    history: false,
                    status: ".page-load-status",
                    scrollThreshold: false,
                    button: ".load-more-link",
                    outlayer: iso,
                    checkLastPage: true,
                });
            }

            /* Filtri combinati */
            let filters = [];
            if ($(".filter-grid").length > 0) {
                $(".griglia-service-row .isotope.filter-value").each(function () {
                    let isPresent;
                    let cat;
                    if ($(this).data("value")) {
                        cat = "." + $(this).data("value");
                        isPresent = $(".griglia-service-row .single-service" + cat).length;
                    } else {
                        cat = "";
                    }
                    $(this).on("click", function () {
                        filters[$(this).parent().data("filter-group")] = cat;

                        var value = "";
                        for (var prop in filters) {
                            value += filters[prop];
                        }

                        iso.arrange({filter: value});
                        $(this).parent().find(".isotope.filter-value").removeClass("active");
                        $(".single-service .service-typo").removeClass("active");

                        var serviceTypo = "";
                        if (filters["province"]) {
                            serviceTypo = ".single-service .service-typo" + filters["province"];
                            $(serviceTypo).addClass("active");
                        } else {
                            serviceTypo = ".single-service .service-typo.generic";
                            $(serviceTypo).addClass("active");
                        }

                        $(this).addClass("active");
                    });
                    if (isPresent <= 0) {
                        $(this).css("display", "none");
                    }
                });
            }

            if ($(".filter-result").length > 0) {
                let filterSelect = $(".filter-select");
                filterSelect.select2({
                    minimumResultsForSearch: -1,
                    dropdownCssClass: "service-filter-dropdown",
                });

                filterSelect.each(function () {
                    if (Cookies.get("isotope_filter")) {
                        var filterGroup = $(this).data("filter-group");

                        var value = JSON.parse(Cookies.get("isotope_filter"))[filterGroup];
                        if (!value) {
                            value = null;
                        }

                        $(this).val(value).trigger("change");
                        setFilterText(filterGroup, value);
                    }

                    $(this).on("select2:select", function () {
                        var selected = $(this).find(":selected");
                        var cat;

                        if (selected.val()) {
                            cat = "." + selected.val();
                        } else {
                            cat = "";
                        }

                        var filterGroup = $(this).data("filter-group");
                        filters[filterGroup] = cat;

                        setFilterText(filterGroup, cat);

                        var value = "";
                        for (var prop in filters) {
                            value += filters[prop];
                        }

                        iso.arrange({filter: value});

                        $(".single-service .service-typo").removeClass("active");
                        var serviceTypo = "";
                        if (filters["province"]) {
                            serviceTypo = ".single-service .service-typo" + filters["province"];
                            $(serviceTypo).addClass("active");
                        } else {
                            serviceTypo = ".single-service .service-typo.generic";
                            $(serviceTypo).addClass("active");
                        }
                    })
                });

                if (Cookies.get("isotope_filter")) {
                    var isotope_filter = JSON.parse(Cookies.get("isotope_filter"));

                    var value = "";
                    for (var prop in isotope_filter) {
                        if (isotope_filter[prop]) {
                            value += "." + isotope_filter[prop];
                        }
                    }

                    iso.arrange({filter: value});
                }
            }


            // let X = Math.floor((Math.random() * 100) - 50);
            // let Y = Math.floor((Math.random() * 100) - 50);

            let X = 0;
            let Y = 0;

            $(".single-service-content").each(function () {

                InertiaPlugin.track($(this), "x,y");

                gsap.to($(this), {
                    inertia: {
                        x: {
                            end: X,
                        },
                        y: {
                            end: Y,
                        },
                    },
                });

                X = X * -1;
                Y = Y * -1;

                let clicked = false;
                $(this).on("click", function () {

                    if (!clicked) {
                        clicked = true;
                        var selectedUserType = $(".filter-select[data-filter-group='usertype']").val();
                        if (selectedUserType) {
                            var userCookie = Util.getUserCookie();
                            var parent = $(this).parent();

                            var types = userCookie["types"];
                            for (var usertype in types) {
                                if (parent.hasClass(types[usertype]) && parseInt(selectedUserType) === parseInt(types[usertype])) {
                                    Util.setCookiePoint(usertype)
                                }
                            }
                        }
                    }
                });
            });
        }

        /* JS INIZIALIZZAZIONE OWLCAROUSEL FLEX-BLOCCO-SEDI.BLADE.PHP */
        let bloccoSediSlider = $(".bs-intestazione .blocco-sedi-slider");
        if (bloccoSediSlider.length > 0) {
            bloccoSediSlider.owlCarousel({
                loop: false,
                nav: true,
                navText: ["<i class=\"far fa-chevron-left\"></i>", "<i class=\"far fa-chevron-right\"></i>"],
                dots: true,
                animateIn: "fadeIn",
                animateOut: "fadeOut",
                center: false,
                items: 1,
            });
        }

        /* JS INIZIALIZZAZIONE ISOTOPE FLEX-BLOCCO-SEDI.BLADE.PHP */
        let areaSedi = $(".bs-area-sedi");
        if (areaSedi.length > 0) {
            let iso = new Isotope(".bs-area-sedi", {
                itemSelector: ".bs-sede-single",
                percentPosition: true,
                masonry: {
                    columnWidth: ".grid-sizer",
                },
            });
        }

        /* JS INIZIALIZZAZIONE OWLCAROUSEL FLEX-BLOCCO-SLIDER-STAFF.BLADE.PHP */
        let sliderSliderStaffHome = $(".bss-staff-container .staff-slider");
        if (sliderSliderStaffHome.length > 0) {
            sliderSliderStaffHome.owlCarousel({
                loop: false,
                nav: true,
                navText: ["<i class=\"far fa-chevron-left\"></i>", "<i class=\"far fa-chevron-right\"></i>"],
                dots: false,
                animateIn: "fadeIn",
                animateOut: "fadeOut",
                responsive: {
                    0: {
                        items: 1,
                        margin: 10,
                    },
                    576: {
                        items: 2,
                        margin: 60,
                    },
                    991: {
                        items: 3,
                        margin: 60,
                    },
                    1200: {
                        items: 3,
                        margin: 100,
                    },
                    1500: {
                        items: 3,
                        margin: 160,
                    },
                },
            });
        }
    },
    onResize() {

    },
};

function setFilterText(filterGroup, category) {
    let notFilteredText = $(".not-filtered-by-" + filterGroup);
    let filteredText = $(".filtered-by-" + filterGroup);

    if (category != "" && !notFilteredText.hasClass("hide")) {
        gsap.to(notFilteredText, {
            opacity: 0, duration: 0.4, onComplete: function () {
                notFilteredText.addClass("hide");
                filteredText.addClass("show");
                gsap.to(filteredText, {
                    opacity: 1,
                    duration: 0.4,
                });
            },
        });
    } else if (category == "") {
        gsap.to(filteredText, {
            opacity: 0, duration: 0.4, onComplete: function () {
                filteredText.removeClass("show");
                notFilteredText.removeClass("hide");
                gsap.to(notFilteredText, {
                    opacity: 1,
                    duration: 0.4,
                });
            },
        });
    }
}



// WEBPACK FOOTER //
// ./scripts/routes/flexible.js